<template lang="pug">
  #network
    .container-fluid
      #journalisttag.pl-0.py-3.pr-3.d-flex.align-items-center(v-if="selectedJournalist['Nombre']"  key="tag")
        i.fas.fa-chevron-left.pl-1.pr-3.large(@click="goBack()")
        p.col-11.my-0.px-0 {{ selectedJournalist["Nombre"] }}
          br 
          span.accent-text Fecha de asesinato: {{ selectedJournalist["Fecha de asesinato"] }}
      .desktop
        .row.d-flex.justify-content-end
          .col-3.details
            p.accent-text Última fecha de publicación
              br
              | {{lastPublication}}
            .row
              .col-6.col-md-12
                .category.d-flex
                  .square.mr-2(v-bind:style="{backgroundColor: colors['Municipio']}")
                  p.mb-0 Municipio: {{selectedJournalist["Municipio de asesinato"]}}
                .category.d-flex
                  .square.mr-2(v-bind:style="{backgroundColor: colors['Estado']}")
                  p.mb-0 Estado: {{selectedJournalist["Estado de asesinato"]}}
                .category.d-flex
                  .square.mr-2(v-bind:style="{backgroundColor: colors['Plataforma']}")
                  p.mb-0 Plataforma: {{selectedJournalist["Plataforma"] && selectedJournalist["Plataforma"].length > 0 ? selectedJournalist["Plataforma"].join(', ') : ''}}
              .col-6.col-md-12
                .category.d-flex
                  .square.mr-2(v-bind:style="{backgroundColor: colors['Partido municipal']}")
                  p.mb-0 Partido en el gobierno municipal: {{selectedJournalist["Partido político Presidente municipal"]}}
                .category.d-flex
                  .square.mr-2(v-bind:style="{backgroundColor: colors['Publicación']}")
                  p.mb-0 Publicación: {{selectedJournalist["Medio"] && selectedJournalist["Medio"].length > 0 ? selectedJournalist["Medio"].join(', ') : ''}}
              .col-6.col-md-12
                p.disclaimer.mt-4 Esta red está basada en la información de 40 de los 111 periodistas para los cuales hay datos en la plataforma
          .col-9.d-flex.justify-content-center.polar
            //Polar
            NetworkChart
      .mobile
        .row.justify-content-center
          .col-12.journalist-network
            h5 Red del periodista
            p.accent-text Última fecha de publicación
              br
              | {{lastPublication}}
          .col-6.col-md-12
            .category.d-flex.row
              .col-3
                .dot.mr-2(v-bind:style="{backgroundColor: colors['Municipio']}")
              .col-9.pl-0
                p.mb-0 Municipio: {{selectedJournalist["Municipio de asesinato"]}}
            .category.d-flex.row
              .col-3
                .dot.mr-2(v-bind:style="{backgroundColor: colors['Estado']}")
              .col-9.pl-0
                p.mb-0 Estado: {{selectedJournalist["Estado de asesinato"]}}
            .category.d-flex.row
              .col-3
                .dot.mr-2(v-bind:style="{backgroundColor: colors['Plataforma']}")
              .col-9.pl-0
                p.mb-0 Plataforma: {{selectedJournalist["Plataforma"] && selectedJournalist["Plataforma"].length > 0 ? selectedJournalist["Plataforma"].join(', ') : ''}}
          .col-6.col-md-12
            .category.d-flex.row
              .col-3
                .dot.mr-2(v-bind:style="{backgroundColor: colors['Partido municipal']}")
              .col-9.pl-0
                p.mb-0 Partido en el gobierno municipal: {{selectedJournalist["Partido político Presidente municipal"]}}
            .category.d-flex.row
              .col-3
                .dot.mr-2(v-bind:style="{backgroundColor: colors['Publicación']}")
              .col-9.pl-0
                p.mb-0 Publicación: {{selectedJournalist["Medio"] && selectedJournalist["Medio"].length > 0 ? selectedJournalist["Medio"].join(', ') : ''}}
          .col-12.mt-3.mt-md-0
            p.disclaimer.mt-4 Esta red está basada en la información de 40 de los 111 periodistas para los cuales hay datos en la plataforma

        .row.mt-5.nodes
          .col-6.col-sm-4.mb-1.px-4(v-for="(journalist, index) in nodes" @click="selectJournalist(journalist)") 
            .dot.mt-3.mb-1(v-bind:style="{background: journalist.color}")
            p {{ journalist.Nombre }}
</template>
<script>
import Polar from "@/components/Polar.vue";
import NetworkChart from "@/components/NetworkChart.vue";

export default {
  name: "Network",
  components: {
    Polar,
    NetworkChart
  },
  data() {
    return {
      colors: {
        "Estado": "#fd7c30",
        "Municipio": "#1a6ba8",
        "Partido municipal": "#fc0f1c",
        "Publicación": "#973a4e",
        "Plataforma": "#42cb1f"
      },
      nodes: []
    }
  },
  computed: {
    allJournalists() {
      return this.$store.state.allJournalists;
    },
    selectedJournalist: {
      get() {
        return this.$store.state.selectedJournalist;
      },
      set(newValue) {
        this.$store.state.selectedJournalist = newValue;
      }
    },
    lastPublication() {
      let sorted = this.selectedJournalist["Publicaciones"];
      if (!sorted) return '';
      if (!sorted[0]) return "Sin información";
      sorted = sorted.sort((a, b) => { new Date(a["FDP"]) - new Date(b["FDP"]) });
      return (new Date(sorted.shift()["FDP"]).toLocaleDateString('es-mx', {dateStyle: "medium"}));
    },
    urlName() {
      return this.selectedJournalist.Nombre.split(" ").join("-");
    }
  },
  watch: {
    selectedJournalist: async function (newValue) {
      await this.getNodes();
      this.$router.push({ path: `/red/${this.urlName}` });
    }
  },
  methods: {
    goBack() {
      this.$router.push({ path: `/periodista/${this.urlName}` });
    },
    selectJournalist(value) {
      this.selectedJournalist = value;
    },
    nodeColor(journalist) {
      let gradient = "linear-gradient(to left, ";
      let clusters = new Set(journalist.clusterBy);
      clusters = Array.from(clusters);
      const totalColors = clusters.length;
      clusters.forEach((c, index) => {
        let color = this.colors[c] ? this.colors[c] : "#ededed";
        gradient += color + ' ' + Math.floor(100 / totalColors * (index)) + '%, ';
        if (index + 1 < totalColors) {
          gradient += color + ' ' + Math.floor(100 / totalColors * (index + 1)) + '%, ';
        }
        else gradient += color + ' 100%)';
      });
      return gradient;
    },
    getNodes() {
      const state = this.selectedJournalist["Estado de asesinato"],
            mun = this.selectedJournalist["Municipio de asesinato"],
            munparty = this.selectedJournalist["Partido político Presidente municipal"],
            media = this.selectedJournalist["Medio"],
            platform = this.selectedJournalist["Plataforma"],
            name = this.selectedJournalist["Nombre"];
      
      this.nodes = this.allJournalists.map(j => {
        const otherstate = j["Estado de asesinato"],
              othermun = j["Municipio de asesinato"],
              othermunparty = j["Partido político Presidente municipal"],
              othermedia = j["Medio"],
              otherplatform = j["Plataforma"],
              mediaIntersect = [media, othermedia].reduce((m, o) => m.filter(x => o.includes(x))),
              platformIntersect = [platform, otherplatform].reduce((m, o) => m.filter(x => o.includes(x) && x != ''));
        j.clusterBy = [];
        

        if (otherstate == state && state) j.clusterBy.push("Estado");
        if (othermun == mun && mun) j.clusterBy.push("Municipio");
        if (othermunparty == munparty && munparty) j.clusterBy.push("Partido municipal");
        if (mediaIntersect.length > 0) j.clusterBy.push("Publicación");
        if (platformIntersect.length > 0) j.clusterBy.push("Plataforma");

        if (j.clusterBy.length > 0 && j["Nombre"] !== name){ 
          j.color = this.nodeColor(j);          
          return j;
        }
      }).filter(j => j);
    },
    async getParams() {
      await this.$store.dispatch("getJournalists");
      const params = this.$route.params.name.replace(/(-)/gi,' ');
      this.selectedJournalist = this.allJournalists.filter(j => j["Nombre"] == params)[0];
    }
  },
  async mounted() {
    if (!this.selectedJournalist["Nombre"]) {
      await this.getParams();
    }
    if (window.innerWidth < 768) this.getNodes();
    window.onresize = () => {
      if (window.innerWidth < 768) this.getNodes();
    }
  }
}
</script>
<style lang="scss">
#network {
  #journalisttag {
    position: fixed;
    top: 2.5rem;
    left: 0;
    background-color: #141414;
    color: #fff;
    font-size: 15px;
    line-height: 1.2;
    width: 280px;
    transition: 0.5s;
    z-index: 2;
    i {
      &:hover {
        cursor: pointer;
        opacity: 0.85;
      }
    }
  }
  .desktop {
    .details {
      top: 9rem;
      position: fixed;
      left: 1rem;
    }
    .category {
      .square {
        width: 1rem;
        height: 1rem;
      }
      p {
        font-size: 13px;
        max-width: 150px;
      }
    }
    .disclaimer {
      font-size: 13px;
      font-weight: bold;
    }
  }
  .mobile {
    .journalist-network {
      margin-top: 10rem;
    }
    .category {
      .dot {
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
      }
      p {
        font-size: 13px;
      }
    }
    .disclaimer {
      font-size: 13px;
      font-weight: bold;
    }
    .nodes {
      .dot {
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        //background-color: olivedrab;
        margin: auto;
      }
    }
  }
}
</style>
